import { useContext,useState} from "react";
import userContext from "./Context";

function Create(){
 
  const[name,setName]=useState("")
  const[email,setEmail]=useState("")
  const[password,setPassword]=useState("")
  const ctx=useContext(userContext);
//   console.log(ctx.users.length)
function handleSubmit(e){
  e.preventDefault()
   const newUsers={name,
                   email,
                   password,
                   amount:0
    }
 ctx.setUsers([...ctx.users, newUsers])
 
  
  
  
}
console.log(ctx)

        return(<>
      <div className="d-flex justify-content-center align-items-center bg-secondary vh-100">
            <div className="bg-white p-3 rounded w-25">
                <h2>Create</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label>Name</label>
                        <input type="text" placeholder="Enter Name" className="form-control rounded-0" onChange={(e)=>{setName(e.target.value)}}></input>
                    </div>

                    <div className="mb-3">
                        <label>Email</label>
                        <input type="email" placeholder="Enter Email" className="form-control rounded-0" onChange={(e)=>{setEmail(e.target.value)}}></input>
                    </div>

                    <div className="mb-3">
                        <label>Password</label>
                        <input type="password" placeholder="Enter Password" className="form-control rounded-0" onChange={(e)=>{setPassword(e.target.value)}}></input>
                    </div>
                    <button type="submit" className="btn btn-success w-100 rounded-0">Submit</button>
                </form>

            </div>
        </div>
    </>)
}
export default Create;